import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ColorLensRoundedIcon from "@mui/icons-material/ColorLensRounded";
import { Box, IconButton } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";

import { updateSingleUserData } from "../../../firebase/user";
import { theme } from "../../../mui-customs/Theme";
import { RootState } from "../../../redux/store";
import TaglineColorSelectorProps from "./tagline-color-selector.interface";
import * as style from "./tagline-color-selector.style";

export const TaglineColorSelector = ({
  isEasyEditable,
}: TaglineColorSelectorProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userUid = useSelector((state: RootState) => state.user.user.uid);
  const setTaglineColor = async (color: string) => {
    userUid &&
      (await updateSingleUserData(
        userUid,
        "taglineColor",
        color,
        "Tagline color updated."
      ));
    setIsModalOpen(false);
  };
  const colorData = [
    "#1abc9c",
    "#2ecc71",
    "#3498db",
    "#9b59b6",
    "#34495e",
    "#f1c40f",
    "#e67e22",
    "#e74c3c",
    "#ecf0f1",
    "#95a5a6",
  ];

  return (
    <>
      <IconButton
        id="basic-button"
        onClick={() => {
          setIsModalOpen((state) => !state);
        }}
        className="EditIcon"
        sx={{
          display: { xs: "none", md: "inline-flex" },
          opacity: isEasyEditable ? 0 : 1,
          position: "absolute",
          right: "10px",
          bottom: "10px",
          zIndex: 4,
          transform: "scale(85%)",
          padding: "7px",
          borderRadius: "6px",
          backgroundColor: theme.brand2[500],
          transition: "0.3s",
          boxShadow: "0px 0px 7px 0px #00000038",
          ":hover": {
            backgroundColor: theme.brand2[600],
          },
        }}
        component="label"
      >
        {isModalOpen ? (
          <CloseRoundedIcon sx={{ color: "#fff", fontSize: "19px" }} />
        ) : (
          <ColorLensRoundedIcon sx={{ color: "#fff", fontSize: "19px" }} />
        )}
      </IconButton>
      <Box
        sx={style.overlay(isModalOpen)}
        onClick={() => setIsModalOpen(false)}
      />

      <Box
        sx={style.colorsContainer(isEasyEditable, isModalOpen)}
        className="EditIcon"
      >
        {colorData.map((each, index) => (
          <IconButton
            key={index}
            sx={style.colorItem(each)}
            onClick={() => setTaglineColor(each)}
          />
        ))}
      </Box>
    </>
  );
};
